


















import { Component, Prop, Vue } from 'vue-property-decorator';
import BookingSearchForm from '@/components/booking/search/Form.vue';

@Component({
  name: 'BookingSearch',
  components: {
    BookingSearchForm,
  },
})
export default class extends Vue {
  get showResult() {
    return this.$route.name === 'booking-search-result';
  }
}
